import { RegisterOptions } from 'react-hook-form'

type ContactFields = {
	name: string
	job_title: string
	email: string
	phone: string
}

export const contactNameRules: RegisterOptions<ContactFields, 'name'> ={
  required: { value: true, message: 'Введите имя контактного лица' },
  minLength: {
    value: 2,
    message: 'Имя должно содержать минимум 2 символа',
  },
  maxLength: {
    value: 60,
    message: 'Имя не должно превышать 60 символов',
  },
  pattern: {
    value: /^[A-Za-zА-Яа-яёЁ\s-]+$/,
    message: 'Имя может содержать только буквы, дефис и пробелы',
  },
}

export const contactPositionRules: RegisterOptions<ContactFields, 'job_title'> = {
  required: { value: true, message: 'Укажите вашу должность' },
  minLength: {
    value: 2,
    message: 'Должность должна быть не короче 2 символов',
  },
  maxLength: {
    value: 80,
    message: 'Должность не должна превышать 80 символов',
  },
}

/* 
  регулярка для телефона предполагает и другие номера помимо стандартных 
  https://habr.com/ru/articles/110731/
*/
export const contactPhoneRules: RegisterOptions<ContactFields, 'phone'> = {
  required: { value: true, message: 'Введите номер телефона для связи' },
  pattern: {
    value: /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/,
    message: 'Введите номер в формате +7 (XXX) XXX-XX-XX',
  },
}

export const contactEmailRules: RegisterOptions<ContactFields, 'email'> =  {
  required: { value: true, message: 'Укажите рабочий e‑mail' },
  pattern: {
    value:
      /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu,
    message: 'Введите корректный e‑mail',
  },
}